import { reportMessageToSentry } from "@coworker/app/src/hooks/useConfigureSentry";
import { honeywellBarcodeResultType } from "../hooks/useBarcodeReader";

export const cameraFailedToReadBarcodeError = (error: unknown) => {
  reportMessageToSentry("Camera: Barcode detection failed", {
    level: "error",
    extra: {
      errorMessage: JSON.stringify(error),
    },
  });
};

export const honeywellFailedToCreateBarcodeReaderError = (
  result: honeywellBarcodeResultType
) => {
  reportMessageToSentry("Honeywell: Failed to create BarcodeReader", {
    level: "error",
    extra: {
      status: result.status,
      message: result.message,
    },
  });
};

export const honeywellFailedToCloseBarcodeReaderError = (
  result: honeywellBarcodeResultType
) => {
  reportMessageToSentry("Honeywell: Failed to close BarcodeReader", {
    level: "error",
    extra: {
      status: result.status,
      message: result.message,
    },
  });
};
